import React, { useState, useRef, useEffect } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";
import useScreenType from "./hooks/useScreenType";

import * as Const from "./_Const";

import Navbar from "./components/Navbar";
import Button from "./components/Button";

function PageErrorLog() {
  const screenType = useScreenType();
  const { logText, sendLogToApi } = useFormCtx();
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
  }, [logText]);

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "textarea":
          css = "text-sm";
          break;
        case "rows":
          css = "16";
          break;
        case "cols":
          css = "50";
          break;
        case "btn":
          css = "h-14 text-sm";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "textarea":
          css = "text-base";
          break;
        case "rows":
          css = "20";
          break;
        case "cols":
          css = "50";
          break;
        case "btn":
          css = "h-20";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "textarea":
          css = "text-base";
          break;
        case "rows":
          css = "24";
          break;
        case "cols":
          css = "50";
          break;
        case "btn":
          css = "h-20";
          break;
      }
    }

    return css;
  }

  return (
    <>
      <Navbar useCustomTitle={true} customTitle={"Log web aplikace"} />
      <div className="mt-4 flex flex-col space-y-4 mx-6">
        <textarea
          className={`${getCssFor("textarea")} bg-disabled`}
          ref={textareaRef}
          value={logText}
          rows={getCssFor("rows")}
          cols={getCssFor("cols")}
          readOnly
        />
        <div className="flex justify-center">
          <Button type="primary" title="Odeslat LOG do API" showIcon={false} onClick={() => sendLogToApi()} className={`${getCssFor("btn")} `} />
        </div>
      </div>
    </>
  );
}

export default PageErrorLog;
